/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BlobFileType } from './BlobFileType';
import {
    BlobFileTypeFromJSON,
    BlobFileTypeFromJSONTyped,
    BlobFileTypeToJSON,
    BlobFileTypeToJSONTyped,
} from './BlobFileType';

/**
 * 
 * @export
 * @interface FileUploadDto
 */
export interface FileUploadDto {
    /**
     * 
     * @type {string}
     * @memberof FileUploadDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileUploadDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileUploadDto
     */
    originalFileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileUploadDto
     */
    blobUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileUploadDto
     */
    contentType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileUploadDto
     */
    order: number;
    /**
     * 
     * @type {number}
     * @memberof FileUploadDto
     */
    fileSizeBytes?: number;
    /**
     * 
     * @type {string}
     * @memberof FileUploadDto
     */
    containerName?: string | null;
    /**
     * 
     * @type {BlobFileType}
     * @memberof FileUploadDto
     */
    fileType?: BlobFileType;
    /**
     * 
     * @type {string}
     * @memberof FileUploadDto
     */
    uploadedByUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileUploadDto
     */
    importSessionId?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FileUploadDto
     */
    metadata?: { [key: string]: string; } | null;
    /**
     * 
     * @type {Date}
     * @memberof FileUploadDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FileUploadDto
     */
    updatedAt?: Date;
}



/**
 * Check if a given object implements the FileUploadDto interface.
 */
export function instanceOfFileUploadDto(value: object): value is FileUploadDto {
    if (!('order' in value) || value['order'] === undefined) return false;
    return true;
}

export function FileUploadDtoFromJSON(json: any): FileUploadDto {
    return FileUploadDtoFromJSONTyped(json, false);
}

export function FileUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileUploadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'originalFileName': json['originalFileName'] == null ? undefined : json['originalFileName'],
        'blobUrl': json['blobUrl'] == null ? undefined : json['blobUrl'],
        'contentType': json['contentType'] == null ? undefined : json['contentType'],
        'order': json['order'],
        'fileSizeBytes': json['fileSizeBytes'] == null ? undefined : json['fileSizeBytes'],
        'containerName': json['containerName'] == null ? undefined : json['containerName'],
        'fileType': json['fileType'] == null ? undefined : BlobFileTypeFromJSON(json['fileType']),
        'uploadedByUserId': json['uploadedByUserId'] == null ? undefined : json['uploadedByUserId'],
        'importSessionId': json['importSessionId'] == null ? undefined : json['importSessionId'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function FileUploadDtoToJSON(json: any): FileUploadDto {
    return FileUploadDtoToJSONTyped(json, false);
}

export function FileUploadDtoToJSONTyped(value?: FileUploadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fileName': value['fileName'],
        'originalFileName': value['originalFileName'],
        'blobUrl': value['blobUrl'],
        'contentType': value['contentType'],
        'order': value['order'],
        'fileSizeBytes': value['fileSizeBytes'],
        'containerName': value['containerName'],
        'fileType': BlobFileTypeToJSON(value['fileType']),
        'uploadedByUserId': value['uploadedByUserId'],
        'importSessionId': value['importSessionId'],
        'metadata': value['metadata'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

